module.exports = __webpack_public_path__ + "static/media/1.bbf66cf1.svg";